import React from "react";
import { Link } from "react-router-dom";
import { API_FILE_URL } from "../../api/config";
import { fileUrl } from "../../i18n/i18n";

const ShopDetails = ({ post, lang }) => {
  if (!post) {
    return <div className="container py-5">404 — Ürün bulunamadı.</div>;
  }

  const t = post.translations?.[lang] || {};
  const cover = fileUrl(API_FILE_URL, post.cover);
  const sideImage = fileUrl(API_FILE_URL, post.sideImage);
  const underImage = fileUrl(API_FILE_URL, post.underImage);
  const categoryFile = fileUrl(API_FILE_URL, post.mainCategory?.file);
  const productFile = fileUrl(API_FILE_URL, post.file);
  const categoryName =
    post.mainCategory?.translations?.[lang]?.name || "Kategori Adı";

  // 🔥 Düzenlenen yer → sadece file var mı kontrolü yapıyoruz
  const hasProductFile = post.file && post.file.trim() !== "";
  const columnClass = hasProductFile ? "col-lg-6" : "col-lg-12";

  return (
    <div className="ltn__shop-details-area">
      {/* 🔥 Sayfaya özel stil */}
      <style>{`
        .ltn__page-details-inner p {
          margin: 0 !important;
        }
      `}</style>
      <div className="container">
        <div className="row">
          {/* Üst Bilgi */}
          <div className="col-12 d-block">
            <div className="ltn__blog-meta mb-2">
              <ul>
                <li className="ltn__blog-category">
                  <Link
                    to={{
                      pathname: "/urunler",
                      state: { categoryId: post.mainCategory?._id },
                    }}
                  >
                    {categoryName}
                  </Link>
                </li>
              </ul>
            </div>

            <div className="product__properties my-20">
              <h4 className="title-2 mt-10">{t.name}</h4>
            </div>
          </div>

          {/* İçerik */}
          {t.content && t.content.trim() !== "" && (
            <div className="col-12 mb-2 shop-details-html">
              <div dangerouslySetInnerHTML={{ __html: t.content }} />
            </div>
          )}

          {/* Sol Sidebar */}
          <div className="col-lg-4">
            <aside className="sidebar ltn__shop-sidebar ltn__right-sidebar---">
              <div
                className="widget ltn__menu-widget ltn__menu-widget-2--- ltn__menu-widget-2-color-2--- mb-10"
                style={{ padding: "20px" }}
              >
                <img
                  src={sideImage && sideImage.trim() !== "" ? sideImage : cover}
                  alt={t.name}
                />
              </div>

              {/* Katalog & PDF */}
              <div className="row">
                <div className={columnClass}>
                  {categoryFile && (
                    <a
                      href={categoryFile}
                      target="_blank"
                      className="btn btn-primary"
                      style={{
                        width: "100%",
                        paddingLeft: "5px",
                        paddingRight: "5px",
                        marginTop: "10px",
                      }}
                      rel="noreferrer"
                    >
                      <i className="fas fa-file-pdf"></i> E-Katalog
                    </a>
                  )}
                </div>

                {hasProductFile && (
                  <div className="col-lg-6">
                    <a
                      href={productFile}
                      target="_blank"
                      className="btn btn-secondary"
                      style={{
                        width: "100%",
                        paddingLeft: "5px",
                        paddingRight: "5px",
                        marginTop: "10px",
                      }}
                      rel="noreferrer"
                    >
                      <i className="fas fa-file-pdf"></i> Ürün PDF
                    </a>
                  </div>
                )}
              </div>
            </aside>
          </div>

          {/* Sağ Büyük İçerik */}
          <div className="col-lg-8 col-md-12">
            <div className="ltn__shop-details-inner ltn__page-details-inner mb-40">
              <div dangerouslySetInnerHTML={{ __html: t.table }} />
            </div>
          </div>

          {/* Alt Görsel */}
          {underImage && underImage.trim() !== "" && (
            <div className="col-lg-12 mb-50">
              <img src={underImage} alt={t.name} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ShopDetails;
